module.exports = __webpack_public_path__ + "static/personmb-8488f88fa91f1b8008d5be7d421e54b6.png";